import React from 'react';
import { ScrollView, View, Text } from 'react-native';
import TreatmentCard from '../components/TreatmentCard';
import MonitoringSection from '../components/MonitoringSection';
import { useAuth } from 'app/auth/hooks/useAuth';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { colorPalette } from '@shared/config/colorsConfig';
import { useNavigation } from '@react-navigation/native';

const MyPathwayScreen = () => {
    const { meData } = useAuth();
    const navigation = useNavigation()
    const handleGoBack = () => {
        navigation.goBack();
    };
    return (
        <MainLayout  navigation={() => handleGoBack()}>
            <ScrollView
                className="flex-1"
                style={{ backgroundColor: colorPalette.white }}
                showsVerticalScrollIndicator={false}
            >
                <View className="py-2">
                    <TreatmentCard pathway={meData?.current_pathway} />
                    <MonitoringSection pathway={meData?.current_pathway} />
                </View>
            </ScrollView>
        </MainLayout >
    );
};

export default MyPathwayScreen;
